import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase environment variables not set. Please configure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.')
}

export const supabase = createClient(
  supabaseUrl || '',
  supabaseAnonKey || ''
)

// Database types
export interface Profile {
  id: string
  username: string
  avatar: string | null
  email: string | null
  total_games_completed: number
  total_time_played: number
  easy_completed: number
  medium_completed: number
  hard_completed: number
  created_at: string
  updated_at: string
}

export interface DbPuzzle {
  id: number
  difficulty: 'beginner' | 'easy' | 'medium' | 'hard'
  level_number: number
  puzzle: string
  solution?: string
  par_time: number
  created_at: string
}

export interface DbGameProgress {
  id: number
  user_id: string
  puzzle_id: number
  current_state: string
  notes: Record<number, number[]> | null
  time_spent: number
  hints_used: number
  mistakes: number
  completed: boolean
  completed_at: string | null
  updated_at: string
}

export interface DbLeaderboardEntry {
  id: number
  user_id: string
  puzzle_id: number
  time_spent: number
  score: number
  completed_at: string
}

